import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import "../../assets/css/datatables/responsive.dataTables.min.css";
import ModalD from "react-awesome-modal";
import {confirmAlert} from "react-confirm-alert"

import jwt_decode from "jwt-decode";

var timestamp = new Date().getTime();

class InvoicesBank extends Component{
    constructor(props) {
        super(props);
        this.state={
            table:{},
            is_download:true,
            merchantID:'',
            chainID:'',
            monthID: '042020',
            model_visible: false,
            changedItems:[],
            file_paths:[],
            isChange: false,
        }
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.get_filtered_data_bank('', this.state.monthID);
        }

        $( document ).ready(function() {
            $('#invoiceTable').on('click', '#invoice_path', function(){
                var path_name = $(this).data("path");
                var tr = $(this).closest('tr');
                if (path_name == null || path_name == 'null' || path_name == '') {
                    alert("PDF for this invoice is not yet generated. Please generate.");
                    return false;
                }

                $.ajax({
                    url:config.get('API_URL')+"/invoice/merchant_download_invoices?file="+path_name,
                    type: 'GET',
                    xhrFields: {
                        responseType: 'blob'
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    success:function(response, status, xhr){ console.log(response);
                        let blob = new Blob([response], {
                            type: "application/pdf"
                        });
                        let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1]
                        //alert(fileName);
                        let rfile = fileName.replace(/\"/g, "");
                        console.log(fileName)
                        let a = document.createElement('a');
                        let url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = rfile;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                });
            });
        })
    }

    get_filtered_data_bank(bid, month) {
        if ($.fn.DataTable.isDataTable('#invoiceTable')) {
            $('#invoiceTable').DataTable().clear().destroy();
        }
        var postData1 = {
            banks_codes: bid,
            month: month
        }
        this.setState({
            monthID: month,
            acqBankIds: bid
        })
        var merchantInvoiceDataTable = $('#invoiceTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo": false,
                "autoWidth": false,
                "responsive": true,
                //"dom": '<"top"lf>t<"bottom"pi><"clear">',
                "searching": true,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url: config.get('API_URL') + "/invoice/banks_invoices",
                    type: 'POST',
                    data: postData1,
                    dataSrc:function ( json ) {

                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns:[
                    {sTitle: "", mData: "acq_bank_name"},
                    {sTitle: "Bank Name", mData: "acq_bank_name"},
                    {sTitle: "GSTNO.", mData: "billing_company_gst_number"},
                    {sTitle: "State.", mData: "state_name"},
                    {sTitle: "Download", mData: "invoice_filepath"},
                    {sTitle: "Invoice Date", mData: "invoice_date"},
                    //{sTitle: " ", mData: "invoice_detail_id"},

                ],
                columns: [
                    {"data": "acq_bank_name"},
                    {"data": "acq_bank_name"},
                    {"data": "billing_company_gst_number"},
                    {"data": "state_name"},
                    {"data": "invoice_filepath"},
                    {"data": "invoice_date"},
                    //{"data": "invoice_detail_id"}
                ],
                columnDefs: [
                    {
                        "width": "10px",
                        "targets": 0,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text("");

                            $(td).append("<input type='checkbox'>");
                            $(td).click(e => {
                                this.check_req(e,rowData["invoice_detail_id"],rowData["invoice_filepath"]);
                            })
                        },
                        bSortable: false,
                    },
                    {
                        render: function (data) {
                            var style = '';
                            if (data == null || data == 'null' || data == '') {
                                style = 'pointer-events: none; display: inline-block; color:#C6C6C6'
                            }
                            return '<td>' +
                                '<ReactTooltip className=\'actionTooltip\' place="bottom" type="dark" effect="solid"/>' +
                                    '<a href="#"  data-tip="Download Invoice" style="'+style+';" title="Download Invoice" id="invoice_path" data-path="'+data+'" >' +
                                        '<i class="fa fa-download" aria-hidden="true"></i>' +
                                    '</a>' +
                                '</td>';
                        },
                        targets: 4,
                        bSortable: false,
                        aTargets: [ -1 ]
                    },
                    // {
                    //     "width": "100px",
                    //     "className": "text-center",
                    //     "targets": 6,
                    //     "data": "data",
                    //     "createdCell": (td, cellData, rowData, row, col) => {
                    //         $(td).text('');
                    //
                    //         $(td).append('<a href="#"  data-tip="Generate Invoice" title="Generate Invoice" id="re_run"  class="generatepdf" >Generate Invoices</a>');
                    //         $(td).click(e => {
                    //             this.check_dw_path(e, rowData);
                    //         })
                    //
                    //     },
                    //     bSortable: false,
                    // }
                ]
            });
    }
    check_dw_path(e){
        // this.state.file_paths.map((path) => {
        //     if(path===null || path==='null') {
        //         alert("hi");
        //     }
        // });
        if(this.state.file_paths.includes(null)===true) {
            this.gen_multiple_pdf(e)
        }
        else{
            confirmAlert({
                title: 'Question',
                message: 'Invoice already exists. Are you sure ?',
                buttons: [{
                    label: 'Yes',
                    onClick: () => {
                        this.gen_multiple_pdf(e);
                    }
                },
                    {
                        label: 'No',
                    }
                ]
            });
        }
    }
    check_req(e, rowData, invoice_path){
        let item_list = this.state.changedItems;
        let fpath = this.state.file_paths;
        let checked_list = rowData;
        let checked_path = invoice_path;
        //console.log(checked_list);
        if(e.target.checked===true) {
            this.setState({
                changedItems: [...this.state.changedItems,  rowData],
                file_paths: [...this.state.file_paths,  invoice_path],
                isChange: true
            });
        } else if(e.target.checked===false){
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                this.setState({
                    changedItems: item_list,
                    isChange: true
                })
            }
            let index1 = fpath.indexOf(checked_path);
            if (index1 > -1) {
                fpath.splice(index1, 1);
                this.setState({
                    file_paths: fpath,
                    isChange: true
                })
            }
        }

        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
        if(this.state.changedItems.length<1) {
            this.setState({
                isChange: false
            })
        }
    }
    gen_pdf(e, rowData) {
        //alert(rowData.invoice_detail_id);
        var ids = [];
        ids.push(rowData.invoice_detail_id);
        this.setState({
            is_download: false,
            model_visible: true
        });
        var postData = {
            invoice_detail_id: ids,
        };

        let xhrBank = $.ajax({
            url: config.get('API_URL') + "/invoice/generate-invoice-pdf",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },

            success: function (response) {

                this.setState({
                    is_download: true,
                    model_visible: false
                })
                this.get_filtered_data_bank(this.state.acqBankIds, this.state.monthID);
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    gen_multiple_pdf(e) {
        //alert(rowData.invoice_detail_id);
        var ids = [];
        ids.push(this.state.changedItems);
        if(this.state.changedItems.length>10){
            alert("Please select maximum 10 records");
            return false;
        }

        this.setState({
            is_download: false,
            model_visible: true
        });
        var postData = {
            invoice_detail_id: this.state.changedItems,
        };

        let xhrBank = $.ajax({
            url: config.get('API_URL') + "/invoice/generate-invoice-pdf",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },

            success: function (response) {

                this.setState({
                    is_download: true,
                    model_visible: false
                })
                this.get_filtered_invoices(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    closeModal() {
        this.setState({
            model_visible: false
        });
    }
    render() {
        // console.log(this.state.changedItems)
        // console.log(this.state.file_paths)
        return(
            <div className="row tansactionTabs">
                <div className="col-md-2 pull-right">
                    <button type="button" className="btn btn-primary" onClick={this.gen_multiple_pdf.bind(this)} disabled={!this.state.isChange}>Generate Invoices</button>
                </div>
                <div className="col-md-12 ">
                    <table id="invoiceTable" className="table table-striped table-hover">
                    </table>
                </div>
                <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                    <div className="download-popup-model">
                        <div className="message-content">
                            {this.state.is_download === false ?
                                <div>
                                    <p>Generating Invoice PDF...</p>
                                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                        <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                    </a>
                                </div>
                                :
                                <div className="dwnloadLink">
                                    <p>Invoice PDF Generated</p>
                                    {/*<a href="#" onClick={this.downloadFile.bind(this)}>*/}
                                    {/*    <i className="fa fa-download" aria-hidden="true"></i>Download*/}
                                    {/*</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*/}
                                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                        <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                    </a>
                                </div>
                            }
                        </div>
                    </div>
                </ModalD>
                <div className="footer">
                    <div className="stats"><i></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default InvoicesBank